import * as React from "react";
import { Block, BlockProps, Responsive } from "baseui/block";
import { useStyletron } from "baseui";

type HorizontalSpacerProps = {
  alignItems?: Responsive<"center" | "end" | "start" | "stretch">;
  gap?: "section" | "inner-section";
  // Technically, all JustifyContent values are valid,
  // but these are the only ones that we want to use.
  justifyContent?: Responsive<
    "left" | "right" | "center" | "space-between" | "space-around"
  >;
  children: React.ReactNode[] | React.ReactNode;
};
export const HorizontalSpacer: React.FC<HorizontalSpacerProps & BlockProps> = (
  props
) => {
  const [, theme] = useStyletron();
  const {
    children = [],
    gap = "inner-section",
    justifyContent = "center",
    alignItems = "center",
    ...restProps
  } = props;
  const gaps = {
    section: theme.sizing.scale600,
    "inner-section": theme.sizing.scale400,
  };

  return (
    <Block
      display="flex"
      flexWrap={true}
      gridRowGap={theme.sizing.scale700}
      gridColumnGap={gaps[gap]}
      alignItems={alignItems}
      justifyContent={justifyContent}
      {...restProps}
    >
      {children?.length > 1
        ? children?.map((child, index) => {
            return child ? (
              <Block key={index} display="flex">
                {child}
              </Block>
            ) : null;
          })
        : children}
    </Block>
  );
};
